<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      size="small"
      :disabled="disabled"
      inline-message
    >
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.form_shipmentDocFileType') || '发运单文档类型'"
            prop="shipmentDocFileType"
          >
            <dict-select
              v-model="formData.shipmentDocFileType"
              :body="shipmentDocFileTypeParams"
              url="/master/common/dict/biz"
              :placeholder="
                $l('INDEX.form_placeholder_shipmentDocFileType') ||
                  '请选择发运单文档类型'
              "
              size="small"
              style="width: 100%"
              filterable
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item :label="$l('INDEX.table_label_remarks') || '备注说明'">
            <el-input
              v-model="formData.remark"
              :placeholder="
                $l('INDEX.order_form_ple_tech_doc_remark') || '请输入备注说明'
              "
              maxlength="250"
              clearable
              show-word-limit
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="disabled">
        <el-col :span="8">
          <el-form-item :label="$l('INDEX.form_shipmentNode') || '发运节点'">
            <dict-select
              v-model="formData.shipmentNode"
              :body="shipmentNodeParams"
              url="/sys/common/dict/system"
              size="small"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('INDEX.form_fileName') || '文档名称'">
            <el-input v-model="formData.fileName" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('INDEX.order_doc_uploadByName') || '上传人'">
            <el-input v-model="formData.uploadByName" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    shipmentDocCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      formData: {},
      shipmentNodeParams: { dictType: 'shipmentNode' },
      shipmentDocFileTypeParams: { dictType: 'shipmentDocFileType' },
      rules: {
        shipmentDocFileType: [
          {
            required: true,
            message: '请选择发运单文档类型',
            trigger: 'change',
          },
        ],
      },
      backDialogVisible: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.shipmentDocCode) return
      this.$api
        .shipmentDocDetailApi({
          shipmentDocCode: this.shipmentDocCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      this.loadingOpen()

      this.$api
        .shipmentDocUpdateApi(this.formData)
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('table_Upload_failed') || '上传失败')
            return
          }
          this.$message({
            showClose: true,
            message:
              this.$l('INDEX.uploader_message_status_success') || '上传成功',
            type: 'success',
          })
          this.$emit('reload')
          this.$emit('close')
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
